"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationSelector = void 0;
const react_1 = __importDefault(require("react"));
const organization_selector_styles_1 = require("./organization-selector.styles");
const localization_1 = require("../../../../../../localization");
const State = __importStar(require("../../../../../../store/state"));
const OrganizationSelector = ({ organizations, selectedOrganization, selectOrganization, }) => {
    var _a;
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const placeholderText = t({ key: 'ORGANIZATIONS' });
    if ((organizations === null || organizations === void 0 ? void 0 : organizations.length) === 1)
        return null;
    const organizationsList = [
        t({ key: State.ORGANIZATIONS_DEFAULT_OPTIONS.NONE.name }),
        ...organizations.map((it) => it.name),
    ];
    return (react_1.default.createElement(organization_selector_styles_1.StyledOrganizationSelector, { className: "", open: true, titleTooltip: false, multiple: false, disabled: false, handleIconButtonClick: () => undefined, primaryCopy: placeholderText, placeholderText: placeholderText, selectionAriaLabel: placeholderText, options: organizationsList, selectedOption: (_a = selectedOrganization === null || selectedOrganization === void 0 ? void 0 : selectedOrganization[0]) !== null && _a !== void 0 ? _a : '', switchOption: selectOrganization, lightMode: true, fullWidth: true, showIcon: false }));
};
exports.OrganizationSelector = OrganizationSelector;
